import * as yup from 'yup';

export const CreateUpdateCoursePlanFormValidation = yup.object().shape({
    idFaculty: yup.string().required('Unidade orgânica é obrigatório'),
    idDepartament: yup.string().required('Departamento é obrigatório'),
    idCourse: yup.string().required('Curso é obrigatório'),
    idAcademicYear: yup.string().required('Ano acadêmico é obrigatório'),
    docBase64: yup.mixed<File>()
        .required('O ficheiro é obrigatório')
        .test('is-file', 'Tipo de ficheiro inválido', (value): value is File => value instanceof File),
});